const state = {
  fljjxx:{name:'全部专题',id:0},
  vicolId:0,
  lawurl:'%B4%E7%9D%80%E4%B8%8D%E5%8A%A0%E7%8F%AD%EF%BC%8C%E5%AE%9E%E9%99%85%E4%B8%8A%E5%90%84%E7%A7%8D%E8%A6%81%E6%B1%82%E5%8A%A0%E7%8F%AD%EF%BC%8C%E5%8A%A0%E7%8F%AD%E6%B2%A1%E9%92%B1',
}

const mutations = {
  upfljjxx(state,upda){
    state.fljjxx = upda
  },
  upvicolId(state,upda){
    state.vicolId = upda
  },
 
}

const actions = {
 
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



